import { initialState } from "./constants";
export default {
	products: [],
	model: initialState()
};
